import React, { useEffect, useState } from 'react';
import {} from 'antd';
import styles from './index.module.less';
import { ShareChannelList } from '@base/lib/share/SharePopupPC';
import cn from 'classnames';
import { IUseShareLink, useShareLink } from 'base/utils/useShareLink';
import { observer, useStoreState } from 'base/store';
import { useTrans } from 'base/utils/i18n'

type IProps = {
    className?: string;
    url?: string;
    title?: string;
    share?: IUseShareLink;
}

const TiledShareList: React.FC<IProps> = observer((props) => {
    const { className, title, url, share } = props

    const shareData = !!share ? share : useShareLink({
        url: url,
        title: title
    });
    const { t } = useTrans();

    return (
        <div className={cn(className, styles['share-warp'], 'flex')}>
            <p className={"g-share-title"}>{t('web_shop_crowdfunding_share_to')}</p>
            <ShareChannelList
                needLogin={false}
                className={"g-share-list"}
                shareUrls={shareData?.shareUrls}
                showName={false}
            />
        </div>
    );
});

export default TiledShareList